<template>
    <div>

       <div class="d-flex align-items-center mt-2">
        <span class="me-auto">
            <span class="me-auto font-logo text-nowrap">
                <slot name="label"></slot>
            </span>
        </span>
        <span>
            <span class="text-break">
                <slot name="message"></slot>
          </span>
        </span>
       </div> 
    </div>
  </template>
  
  <script>
  export default {
    name: "App",
    props: {
      label: {
        type: String,
        default: () => "",
      },
      message: {
        type: String,
        default: () => "",
      },
    },
    data() {
      return {};
    },
    methods: {},
    computed: {},
    watch: {},
    components: {},
  };
  </script>
  
  <style></style>
  